import { render, staticRenderFns } from "./EducationTest.vue?vue&type=template&id=6981e219&"
import script from "./EducationTest.vue?vue&type=script&lang=js&"
export * from "./EducationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports